import NotFoundPrivatePage from '@/pages/private/NotFoundPrivatePage';
import NavBar from '@/shared/components/navbar/NavBar';

/**
 * Layout de error para manejar errores en rutas privadas (404 y otros errores).
 *
 * Funcionalidad:
 * - Proporciona una interfaz consistente para mostrar errores dentro del área privada
 * - Mantiene la navbar visible para permitir navegación incluso en caso de error
 * - Muestra la página de error Not Found de forma estilizada
 *
 * Responsabilidades:
 * - Renderizar la navbar de navegación para mantener la experiencia del usuario
 * - Mostrar el componente NotFoundPrivatePage con los estilos adecuados
 * - Mantener la estructura de layout consistente con las rutas privadas
 */
const PrivateErrorLayout = () => {
  return (
    <div className="relative flex flex-col gap-2 h-screen p-1">
      <NavBar />

      <main className="flex flex-col gap-2 rounded-xl min-h-0 flex-1 overflow-auto">
        <NotFoundPrivatePage />
      </main>
    </div>
  );
};

export default PrivateErrorLayout;
